//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Product } from "@nuskin/ns-shop";
import {
  events,
  ConfigService,
  SitesSessionStorageService
} from "@nuskin/ns-util";
import { NsIcon } from "@nuskin/design-components";
import {
  NsProductListSortable,
  NsProductCarousel
} from "@nuskin/product-components";
import { getProp } from "@nuskin/ns-common-lib";

const SEARCH_TERM_KEY = "searchResultsData";

export default {
  name: "NsSearchResults",
  components: { NsIcon, NsProductListSortable, NsProductCarousel },
  props: {
    showSearchResults: Boolean,
    translations: {
      type: Object,
      default: () => ({})
    },
    noResultsImageUrl: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      marketConfig: ConfigService.getMarketConfig(),
      query: "",
      searchResults: [],
      searchResultsText: "",
      sortBySelected: "bestMatch"
    };
  },
  computed: {
    resultsSkus() {
      const searchResult =
        !!this.searchResults && this.searchResults.length > 0
          ? this.searchResults[0]
          : undefined;
      return searchResult ? searchResult.resultsList || [] : [];
    },
    hasResults() {
      return this.resultsSkus.length > 0;
    },
    skusWithScores() {
      return this.resultsSkus.reduce((result, product) => {
        result[product.sku] = product.searchScore;
        return result;
      }, {});
    },
    skus() {
      return this.hasResults ? Object.keys(this.skusWithScores) : [];
    },
    localNoResultsImageUrl() {
      return (
        this.noResultsImageUrl ||
        `${this.marketConfig.siteUrl}/etc/designs/hello/packaged/img/noResults.png`
      );
    }
  },
  mounted() {
    if (this.showSearchResults) {
      this.setResultsFromLocalStorage();
    }

    events.subscribe(events.shop.SEARCH_EXECUTED, this.handleSearchExecuted);
  },
  destroyed() {
    events.unsubscribe(events.shop.SEARCH_EXECUTED, this.handleSearchExecuted);
  },
  methods: {
    handleSortBySelect(selected) {
      this.sortBySelected = selected;
    },

    back() {
      this.$emit("back-button-clicked");
    },

    resultsUpdated() {
      this.updateSearchForText();
      if (this.hasResults) {
        for (let i = 0; i < this.searchResults[0].resultsList.length; i++) {
          this.searchResults[0].resultsList[i] = new Product(
            this.searchResults[0].resultsList[i]
          );
        }

        this.saveResultsToLocalStorage();
      }

      events.publish("closeSpinner");
      this.$emit("scroll-to-top");
    },

    updateSearchForText() {
      const SEARCH_TERM = "%searchTerm%";
      const SEARCH_RESULTS_NUMBER = "%searchResultsNumber%";

      this.searchResultsText = this.t("searchResultsFor", "")
        .replace(SEARCH_TERM, '<span id="query">"' + this.query + '"</span>')
        .replace(SEARCH_RESULTS_NUMBER, this.resultsSkus.length);
    },

    saveResultsToLocalStorage() {
      let searchResults = SitesSessionStorageService.getItem(SEARCH_TERM_KEY);
      searchResults = !searchResults ? {} : JSON.parse(searchResults);

      if (this.query) {
        searchResults.query = this.query;
      }

      if (this.searchResults && this.searchResults.length > 0) {
        searchResults.searchResults = this.searchResults;
      }

      SitesSessionStorageService.writeItem(
        SEARCH_TERM_KEY,
        JSON.stringify(searchResults)
      );
    },

    setResultsFromLocalStorage() {
      let resultsData = SitesSessionStorageService.getItem(SEARCH_TERM_KEY);
      if (resultsData) {
        resultsData = JSON.parse(resultsData);
        this.query = resultsData.query;
        this.searchResults = resultsData.searchResults;
      }
    },

    handleSearchExecuted(searchObject) {
      if (searchObject && searchObject.showSearchResults) {
        this.sortBySelected = "bestMatch";
        this.query = searchObject.query || "";
        this.searchResults = searchObject.resultsObject || [];

        if (this.searchResults && this.searchResults.length) {
          this.resultsUpdated();
        }
      }
    },

    t(key, defaultVal) {
      return getProp(this.translations, key, defaultVal);
    }
  }
};
